import { Paragraph, SyntaxIcon } from '@expressable/syntax-ds';
import { Person, Clock } from '@phosphor-icons/react';
import clsx from 'clsx';

export const DateChipAdornment = ({ count, disabled }: { count: number; disabled?: boolean }) => (
  <Paragraph size="xs" className={clsx('flex gap-px', { 'text-disabled': disabled })}>
    {count} <SyntaxIcon icon={Person} className={`${disabled ? 'text-warm-gray-400' : 'text-purple-400'}`}></SyntaxIcon>
  </Paragraph>
);

export const TimeSlotChipAdornment = ({ count, disabled }: { count: number; disabled?: boolean }) => (
  <Paragraph size="xs" className={clsx('flex gap-px', { 'text-disabled': disabled })}>
    {count} <SyntaxIcon icon={Clock} className={`${disabled ? 'text-warm-gray-400' : 'text-purple-400'}`}></SyntaxIcon>
  </Paragraph>
);
